"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordType = void 0;
var RecordType;
(function (RecordType) {
    RecordType["VirtualFullCeremony"] = "VirtualFullCeremony";
    RecordType["HybridClipsOnly"] = "HybridClipsOnly";
    RecordType["HybridFullCeremony"] = "HybridFullCeremony";
    RecordType["LiveClipsOnly"] = "LiveClipsOnly";
    RecordType["VirtualClipsOnly"] = "VirtualClipsOnly";
})(RecordType = exports.RecordType || (exports.RecordType = {}));
//# sourceMappingURL=record-type.js.map